import Utils from "../../../shared/utils";

export const POINT_ANIMATION = Utils.buildProductPageImageLink("rent/doublecheck/point-animation.svg");
